import React from 'react';
import cn from 'classnames';
import { Card } from 'reactstrap';

const IngredientDetailCard = ({ className, name, description }) => (
  <Card className={cn(className, 'pa3')}>
    <div>
      <h3 className="f4 mt0">{name}</h3>
      {description && <p>{description}</p>}
    </div>
  </Card>
);

export default IngredientDetailCard;



// WEBPACK FOOTER //
// ./src/components/ingredientDetailCard/ingredientDetailCard.jsx